import {
  executions,
  growthStages,
} from '@/modules/execution/mock/executionsSeeds'
import { pauseReasons, programs } from '@/modules/execution/mock/programSeeds'
import { varieties } from '@/pages/cultivares/mock/varietySeeds'
import { APIFailureWrapper, mockFlag } from '@/utils/mock'

const programRoutes = [
  mockFlag(
    {
      method: 'get',
      url: '/programas',
      result: ({ queryParams }) => {
        let response = []
        if (queryParams.semeadura_id) {
          const associatedProgram = programs.find(
            (program) => program.semeadura_id == queryParams.semeadura_id
          )
          if (associatedProgram) {
            const associatedExecutions = executions.reduce((acc, execution) => {
              if (execution.programa_id == associatedProgram.id) {
                acc.push({
                  aplicacao: execution.aplicacao,
                  created_at: execution.created_at,
                  data_aplicacao_planejada: execution.data_aplicacao_planejada,
                  data_ideal: execution.data_ideal,
                  data_realizada: execution.data_realizada,
                  doenca_prioritaria_id: execution.doenca_prioritaria_id,
                  doenca_secundaria_1_id: execution.doenca_secundaria_1_id,
                  doenca_secundaria_2_id: execution.doenca_secundaria_2_id,
                  doencas_sugeridas: execution.doencas_sugeridas,
                  eficacia_ajustada: execution.eficacia_ajustada,
                  eficacia_potencial: execution.eficacia_potencial,
                  eficacias: execution.eficacias,
                  estadio_nao_recomendado: execution.estadio_nao_recomendado,
                  execucao_adjuvantes: execution.execucao_adjuvantes,
                  execucao_defensivos: execution.execucao_defensivos,
                  id: execution.id,
                  num_programa: execution.num_programa,
                  programa_id: execution.programa_id,
                  updated_at: execution.updated_at,
                })
              }

              return acc
            }, [])

            response = [
              {
                execucoes: associatedExecutions,
                programa: {
                  created_at: associatedProgram.created_at,
                  cultivar_id: associatedProgram.cultivar_id,
                  dae: associatedProgram.dae,
                  data_prevista: associatedProgram.data_prevista,
                  doenca_prioritaria_id:
                    associatedProgram.doenca_prioritaria_id,
                  doenca_secundaria_1_id:
                    associatedProgram.doenca_secundaria_1_id,
                  doenca_secundaria_2_id:
                    associatedProgram.doenca_secundaria_2_id,
                  doencas_sugeridas: associatedProgram.doencas_sugeridas,
                  id: associatedProgram.id,
                  imported_from_planning_id:
                    associatedProgram.imported_from_planning_id,
                  is_paused_by_climate: associatedProgram.is_paused_by_climate,
                  nome: associatedProgram.nome,
                  racional_id: associatedProgram.racional_id,
                  semeadura_id: associatedProgram.semeadura_id,
                  severidade_id: associatedProgram.severidade_id,
                  total_aplicacoes_sugeridas:
                    associatedProgram.total_aplicacoes_sugeridas,
                  updated_at: associatedProgram.total_aplicacoes_sugeridas,
                  white_mold_enabled: associatedProgram.white_mold_enabled,
                  white_mold_total_sprayings:
                    associatedProgram.white_mold_total_sprayings,
                },
              },
            ]
          } else {
            response = programs.filter(
              (program) => program.cultivar_id == queryParams.cultivar_id
            )
          }
        } else {
          response = programs.filter(
            (program) => program.cultivar_id == queryParams.cultivar_id
          )
        }

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de programas',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/programs/:id/growth-stages',
      result: ({ params }) => {
        const selectedProgram = programs.find(
          (program) => program.id == params.id
        )
        const cropId = varieties.find(
          (variety) => variety.id == selectedProgram.cultivar_id
        ).crop.id
        const varietyGrowthStages = growthStages[cropId]

        const response = varietyGrowthStages.map((growthStage) => {
          return {
            id: growthStage.id,
            message_key: growthStage.message_key,
            name: growthStage.name,
            value: growthStage.value,
          }
        })

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de growth-stages',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/paused-climate-reasons',
      result: () => {
        const response = pauseReasons

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de motivos para pausa do programa',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'post',
      url: '/programs/:id/pause',
      result: ({ params }) => {
        programs.forEach((program) => {
          if (program.id == params.id) {
            program.is_paused_by_climate = true
          }
        })

        return APIFailureWrapper({
          content: null,
          errorMessage: 'Erro na pausa do programa',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'post',
      url: '/programs/:id/resume',
      result: ({ params }) => {
        programs.forEach((program) => {
          if (program.id == params.id) {
            program.is_paused_by_climate = false
          }
        })

        return APIFailureWrapper({
          content: null,
          errorMessage: 'Erro na despausa do programa',
        })
      },
    },
    'on'
  ),
]

export { programRoutes }
